import { c as _c } from "react/compiler-runtime";
import { Badge, cn } from '@newfront-insurance/core-ui/v2';
import type { JSX } from 'react';
import { type NovaSearchAccountResult } from './use-account-search';
interface SearchRowProps {
  account: NovaSearchAccountResult | null;
  onClick?: () => void;
  isSelected?: boolean;
  className?: string;
}
export function SearchRow(t0) {
  const $ = _c(13);
  const {
    account,
    onClick,
    isSelected: t1,
    className
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== isSelected) {
    const baseButtonClasses = cn("hover:bg-muted flex w-full text-left", {
      "bg-brand-200": isSelected
    }, className);
    t2 = "button";
    t3 = cn(baseButtonClasses, "items-start gap-2 px-3 py-2");
    $[0] = className;
    $[1] = isSelected;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== account) {
    t4 = account && <><div className="flex items-center justify-between"><span className="truncate text-sm font-medium">{account.label}</span>{account.badges && account.badges.length > 0 && <div className="flex gap-1">{account.badges.map(_temp)}</div>}</div>{account.description && <div className="text-muted-foreground truncate text-xs">{account?.description ?? "Chat without account context."}</div>}</>;
    $[4] = account;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="min-w-0 flex-1 space-y-1">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onClick || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <button type={t2} className={t3} onClick={onClick}>{t5}</button>;
    $[8] = onClick;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp(badge) {
  const badgeVariant = badge === "TR" ? "glitter" : "primary";
  return <Badge key={badge} variant={badgeVariant} className={cn("px-2 text-xs", {
    "bg-[#021a3c] text-white": badge === "BI"
  })}>{badge}</Badge>;
}